import React from 'react';
import '../styles/Legal.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>이용약관</h1>
        <p style={{color: '#999', fontSize: '0.9rem', marginBottom: '30px'}}>시행일: 2024년 1월 1일 | 최종 수정: 2025년 3월 1일</p>

        <section>
          <h2>제1조 (목적)</h2>
          <p>본 약관은 마인드랩(이하 "서비스")이 제공하는 온라인 심리 검사 서비스의 이용에 관한 조건 및 절차, 서비스 제공자와 이용자 간의 권리·의무 및 책임 사항을 규정함을 목적으로 합니다.</p>
        </section>

        <section>
          <h2>제2조 (서비스의 목적 및 내용)</h2>
          <p>마인드랩은 심리학 이론에 기반한 무료 온라인 성격·심리 검사를 제공합니다. 현재 제공하는 검사는 다음과 같습니다:</p>
          <ul>
            <li>MBTI 성격유형 검사 (카를 융의 심리유형론 기반)</li>
            <li>에니어그램 성격유형 검사 (9가지 유형 분류)</li>
            <li>애착유형 검사 (존 볼비의 애착이론 기반)</li>
          </ul>
          <p>본 서비스는 자기이해와 오락 목적으로 제공되며, 공인된 심리 검사 기관의 검사를 대체하지 않습니다.</p>
        </section>

        <section>
          <h2>제3조 (서비스 이용 조건)</h2>
          <p>본 서비스는 별도 회원가입 없이 무료로 이용 가능합니다. 이용자는 다음 사항을 준수해야 합니다:</p>
          <ul>
            <li>본 서비스를 법령, 공공질서, 미풍양속에 반하는 방식으로 이용하지 않을 것</li>
            <li>서비스의 정상적인 운영을 방해하는 행위(자동화 도구 사용, 과도한 트래픽 발생 등)를 하지 않을 것</li>
            <li>본 서비스의 콘텐츠를 무단으로 복제, 배포, 상업적으로 이용하지 않을 것</li>
          </ul>
        </section>

        <section>
          <h2>제4조 (검사 결과의 한계)</h2>
          <p>본 서비스에서 제공하는 심리 검사 결과는 다음과 같은 한계를 가집니다:</p>
          <ul>
            <li>전문 심리 상담사의 진단을 대체할 수 없습니다.</li>
            <li>결과는 자기보고식 검사의 특성상, 응답 당시의 기분이나 상황에 따라 달라질 수 있습니다.</li>
            <li>동일한 검사를 여러 번 시행 시 결과가 다를 수 있습니다.</li>
            <li>검사 결과는 참고 자료이며, 이를 근거로 한 중요한 결정에 대한 책임은 이용자 본인에게 있습니다.</li>
          </ul>
          <p>심각한 심리적 어려움이 있거나 정신건강 문제가 의심되는 경우, 반드시 전문 의료 기관이나 상담 기관을 방문하시기 바랍니다.</p>
        </section>

        <section>
          <h2>제5조 (광고 서비스)</h2>
          <p>본 서비스는 Google AdSense를 통한 광고를 포함하고 있습니다. 광고 수익은 서비스의 무료 운영을 위해 사용됩니다.</p>
          <ul>
            <li>광고는 이용자의 관심사와 브라우징 정보를 기반으로 맞춤형으로 제공될 수 있습니다.</li>
            <li>광고 콘텐츠에 대한 책임은 해당 광고주에게 있으며, 서비스는 광고 내용에 대해 보증하지 않습니다.</li>
            <li>이용자는 브라우저 설정 또는 <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer" style={{color: '#667eea'}}>Google 광고 설정</a>을 통해 맞춤형 광고를 거부할 수 있습니다.</li>
          </ul>
        </section>

        <section>
          <h2>제6조 (콘텐츠 저작권)</h2>
          <p>본 서비스에서 제공하는 모든 콘텐츠(텍스트, 이미지, 검사 질문, 결과 설명 등)는 저작권법의 보호를 받습니다.</p>
          <p>이용자는 개인적인 비상업적 목적으로만 결과를 활용할 수 있으며, 서비스의 사전 허가 없이 콘텐츠를 복제, 수정, 배포, 상업적으로 이용할 수 없습니다.</p>
        </section>

        <section>
          <h2>제7조 (서비스 변경 및 중단)</h2>
          <p>서비스는 운영상 또는 기술상의 이유로 사전 고지 없이 서비스의 내용을 변경하거나 일시적으로 중단할 수 있습니다. 서비스 변경이나 중단으로 인해 이용자에게 손해가 발생하더라도, 이에 대한 책임을 지지 않습니다.</p>
        </section>

        <section>
          <h2>제8조 (책임 제한)</h2>
          <p>서비스는 다음과 같은 경우 책임을 지지 않습니다:</p>
          <ul>
            <li>이용자가 검사 결과를 근거로 내린 결정으로 발생한 손해</li>
            <li>천재지변, 해킹, 통신 장애 등 불가항력으로 인한 서비스 중단</li>
            <li>이용자의 귀책사유로 인한 서비스 이용 장애</li>
            <li>제3자 서비스(Google Analytics, AdSense 등)의 정책 변경이나 장애로 인한 영향</li>
          </ul>
        </section>

        <section>
          <h2>제9조 (분쟁 해결)</h2>
          <p>본 약관과 관련된 분쟁은 대한민국 법률에 따라 해결합니다. 서비스와 이용자 간 분쟁이 발생할 경우, 서로 원만히 해결하도록 노력하며, 합의가 이루어지지 않을 경우 관련 법령에 따른 절차를 따릅니다.</p>
        </section>

        <section>
          <h2>제10조 (문의)</h2>
          <p>약관에 관한 문의 사항은 아래로 연락 주세요.</p>
          <p>이메일: <a href="mailto:yong8master@gmail.com" style={{color: '#667eea'}}>yong8master@gmail.com</a></p>
          <p style={{fontSize: '0.85rem', color: '#999', marginTop: '20px'}}>본 약관은 2025년 3월 1일부터 시행됩니다.</p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
